import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    ConfigurationManagerContainer,
    PageHeader,
    PageWrapper,
} from 'src/domains/layouts/webview/ConfigurationManager/configurationManager.style';
import { ServiceSettingsList } from 'src/domains/layouts/webview/ConfigurationManager/serviceSettingsList/serviceSettingsList';
import { ServiceSettingsFormWrapper } from 'src/domains/layouts/webview/ConfigurationManager/serviceSettingsForm/serviceSettingsForm';
import { useCommon } from 'src/AppState/Common';
import { ConfigurationManagerState } from 'src/domains/layouts/webview/ConfigurationManager/configurationManager.state';

export const ConfigurationManager = observer('ConfigurationManager', (): React.ReactElement => {
    const common = useCommon();
    const state = ConfigurationManagerState.get(common);

    return (
        <PageWrapper className='font-tertiary'>
            <PageHeader>Configuration Manager</PageHeader>
            <ConfigurationManagerContainer>
                {state.services.get().type === 'loading' && <h1>Loading...</h1>}
                {state.services.getReady()?.map((service) => (
                    <ServiceSettingsList
                        key={service.id}
                        service={service}
                    />
                ))}

                <ServiceSettingsFormWrapper currentServiceId={state.currentServiceId} />
            </ConfigurationManagerContainer>
        </PageWrapper>
    );
});
